import React, { useEffect, memo } from 'react';

import { CCAdminListStore } from '../store';
import { Modal, Alert } from 'antd';

import { runInAction } from 'mobx';
import _ from 'lodash';
import { MOpNameDisplayContainer } from '@/components';
import { observer } from 'mobx-react-lite';
import { tryRefresh } from '@/utils';

export const ActionMDelete: React.FC<{
    defaultStore: CCAdminListStore;
}> = observer(({ defaultStore }) => {
    const { defaultMSelect } = defaultStore;
    const { mSeletedData } = defaultMSelect;
    if (mSeletedData === null || mSeletedData.length === 0) {
        return null;
    }
    const visible = defaultStore.actionType === 'm-delete';
    return (
        <Modal
            visible={visible}
            title={'批量删除坐席'}
            onCancel={() => {
                defaultStore.resetAction();
            }}
            onOk={async () => {
                const ok = await defaultStore.mdelete();
                if (ok) {
                    runInAction(() => {
                        defaultStore.resetAction();
                        defaultMSelect.removeAllSelectedData();
                        tryRefresh(['sys_call_center_user']);
                    });
                }
            }}
        >
            <h4>
                是否将选择的{mSeletedData.length}个坐席删除？
                <MOpNameDisplayContainer
                    defaultStore={defaultStore}
                    nameParam="name"
                />
            </h4>
            <Alert type="error" message="删除成功之后，该操作无法恢复。" />
        </Modal>
    );
});
